import { AnalyticsBrowser } from '@segment/analytics-next'

import { campaignContextPlugin } from '@/lib/campaign-context-plugin'

const gridAnalytics = AnalyticsBrowser.load({
  writeKey: `${process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}`,
  plugins: [campaignContextPlugin],
})

export default gridAnalytics
